import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbStatusDropdown from '../Buttons/SbStatusDropdown';
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../PaginationComponent';
import Skeleton from 'react-loading-skeleton';
import noDataFound from '../../assets/images/no-data-found.svg'
import { formatDate } from '../DateTimeUtils';
import { useDispatch, useSelector } from 'react-redux';
import attachment from '../../assets/images/Dashboard/attachment-download-img.svg';

const columns = [
    { id: 'LeaveID', label: 'ID', align: 'left', minWidth: '80px' },
    { id: 'UserName', label: 'NAME', align: 'left', minWidth: '150px' },
    { id: 'EmailID', label: 'Email.ID', align: 'left', minWidth: '200px' },
    // { id: 'Phone', label: 'CONTACT', align: 'left', minWidth: '100px' },
    { id: 'LeaveTypeName', label: 'LEAVE TYPE', align: 'left', minWidth: '150px' },
    { id: 'DepartmentName', label: 'DEPARTMENT', align: 'left', minWidth: '150px' },
    { id: 'ReportingTo', label: 'REPORTING TO', align: 'left', minWidth: '150px' },
    { id: 'AppliedOn', label: 'APPLIED ON', align: 'left', minWidth: '180px' },
    { id: 'StartDate', label: 'START DATE', align: 'left', minWidth: '180px' },
    { id: 'EndDate', label: 'END DATE', align: 'left', minWidth: '180px' },
    { id: 'LeaveDuration', label: 'LEAVE DURATION', align: 'left', minWidth: '180px' },
    { id: 'Reason', label: 'REASON', align: 'left', minWidth: '200px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '130px' },
    { id: 'Action', label: 'ACTION', align: 'left', minWidth: '130px' },
];

const LeavesTable = ({ leaveData = [], totalDataCount, rowsPerPage, page, setPage, setRowsPerPage, handleStatusChange, loading, singleLeaveData = [], signInDetails }) => {
    const navigate = useNavigate(); // Initialize navigate

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [leaveId, setLeaveId] = useState(null);
    // Pagination state
    const [paginatedData, setPaginatedData] = useState([]);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    // const sortedData = React.useMemo(() => {
    //     const stabilizedData = leaveData.map((el, index) => [el, index]);
    //     stabilizedData.sort((a, b) => {
    //         const orderModifier = order === 'asc' ? 1 : -1;
    //         if (a[0][orderBy] < b[0][orderBy]) {
    //             return -1 * orderModifier;
    //         }
    //         if (a[0][orderBy] > b[0][orderBy]) {
    //             return 1 * orderModifier;
    //         }
    //         return a[1] - b[1];
    //     });
    //     return stabilizedData.map((el) => el[0]);
    // }, [leaveData, order, orderBy]);

    // Pagination logic


    useEffect(() => {
        if (!leaveData || leaveData.length === 0) {
            console.warn("⚠️ No Leave Data Found!");
            setPaginatedData([]);
            return;
        }

        // Sort data based on order & orderBy
        const sorted = [...leaveData].sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
        });

        // Calculate pagination
        const maxPage = Math.ceil(sorted.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = sorted.slice(start, end);

        setPaginatedData(paginated);
    }, [leaveData?.length, order, orderBy, page, rowsPerPage]);

    useEffect(() => {
        if (
            signInDetails?.length > 0 &&
            signInDetails[0]?.SignInType === "User" &&
            signInDetails[0]?.HasSubordinates === "Yes"
        ) {
            if (!Array.isArray(singleLeaveData) || singleLeaveData.length === 0) {
                console.warn("⚠️ No Leave Data Found or Data is Not an Array!", singleLeaveData);
                setPaginatedData([]);
                return;
            }

            // Calculate pagination
            const maxPage = Math.ceil(singleLeaveData.length / rowsPerPage);
            const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

            const start = newPage * rowsPerPage;
            const end = start + rowsPerPage;
            const paginated = singleLeaveData.slice(start, end);

            // Only update state if paginated data has changed
            setPaginatedData(prev =>
                JSON.stringify(prev) === JSON.stringify(paginated) ? prev : paginated
            );
        } else {
            if (!leaveData || leaveData.length === 0) {
                console.warn("⚠️ No Leave Data Found!");
                setPaginatedData([]);
                return;
            }

            // Sort data based on order & orderBy
            const sorted = [...leaveData].sort((a, b) => {
                const orderModifier = order === "asc" ? 1 : -1;
                return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
            });

            // Calculate pagination
            const maxPage = Math.ceil(sorted.length / rowsPerPage);
            const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

            const start = newPage * rowsPerPage;
            const end = start + rowsPerPage;
            const paginated = sorted.slice(start, end);

            setPaginatedData(paginated);
        }
    }, [singleLeaveData, leaveData, order, orderBy, page, rowsPerPage, signInDetails]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    const handleRowClick = (leaveId) => {
        navigate(`/leaveDetails/${leaveId}`); // Navigate to leaveDetails with the customer ID
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} className='table-header-div'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {column.label}
                                        {column.sortable !== false && (
                                            <IconButton
                                                size="small"
                                                onClick={(event) => handleRequestSort(event, column.id)}
                                            >
                                                <img src={SortIcon} alt="Sort" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            loading ? (
                                [...Array(rowsPerPage)].map((_, index) => (
                                    <TableRow key={index}>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                <Skeleton height={40} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : paginatedData.length === 0 ? (
                                // Display "No Data Found" row if no data is present in the paginated data
                                <TableRow>
                                    <TableCell colSpan={columns.length}>
                                        <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                paginatedData.map((customer) => (
                                    <TableRow key={customer.id} >
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                {column.id === 'Status' ? (
                                                    <span>
                                                        <SbStatusDropdown customer={customer} onStatusChange={(status, reason) => { handleStatusChange(customer, status, reason) }} />
                                                    </span>
                                                ) : (
                                                    column.id === 'UserName' ? (
                                                        <span style={{ cursor: "pointer" }}
                                                            onClick={() => handleRowClick(customer.LeaveID)}
                                                        >
                                                            {customer[column.id]}
                                                        </span>
                                                    ) : column.id === 'EmailID' ? (  // Combine Email & Contact in one cell
                                                        <div>
                                                            <div>{customer[column.id]}</div>  {/* Email */}
                                                            <div className='leaves-contact-number '>{customer.Phone}</div>  {/* Contact */}
                                                        </div>
                                                    ) : column.id === 'AppliedOn' ? (
                                                        formatDate(customer[column.id]) // Format the Date field
                                                    ) : column.id === 'StartDate' ? (
                                                        formatDate(customer[column.id]) // Format the Date field
                                                    ) : column.id === 'EndDate' ? (
                                                        formatDate(customer[column.id]) // Format the Date field
                                                    ) : column.id === "Action" ? (
                                                        customer.FilePath ? (
                                                            <img
                                                                src={attachment}
                                                                alt="Download"
                                                                data-toggle="tooltip" data-placement="right" title="Download"
                                                                className="download-image"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={async () => {
                                                                    try {
                                                                        const response = await fetch(customer.FilePath, { mode: "cors" });
                                                                        const blob = await response.blob();
                                                                        const url = window.URL.createObjectURL(blob);

                                                                        const link = document.createElement("a");
                                                                        link.href = url;
                                                                        link.download = customer.FileName || "leave-document";
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);

                                                                        window.URL.revokeObjectURL(url);
                                                                    } catch (error) {
                                                                        console.error("Download failed:", error);
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <span>No File</span>
                                                        )
                                                    ) : (
                                                        customer[column.id]
                                                    )
                                                )}
                                            </TableCell>

                                        ))}
                                    </TableRow>
                                )))}
                    </TableBody>
                </Table>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem onClick={() => handleSortOrderChange('asc')}>
                        <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                        Ascending to Descending
                    </MenuItem>
                    <MenuItem onClick={() => handleSortOrderChange('desc')}>
                        <img src={descToAsc} alt="" />&nbsp;&nbsp;
                        Descending to Ascending
                    </MenuItem>
                </Menu>
            </TableContainer>
            {/* Use PaginationComponent */}
            <PaginationComponent
                totalItems={totalDataCount}
                itemsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </>
    );
};

export default LeavesTable;
